module.exports = __webpack_public_path__ + "928c3918eafc60637fcc30ac40b4babb.svg";